/* eslint-disable react/display-name */
import React from 'react';
import styled from 'styled-components';

import { reduxConnect } from '../../../common';
/** @ts-expect-error - Ignoring Could not find a declaration file for module '@weatherbug/react' since don't have TS types for @weatherbug/react package... yet. */
import { Map, RasterLayer } from '@weatherbug/react';
import { IStoreState } from '../interfaces/types';

// TechDebt:
// Need to figure out how we can properly import these mapbox styles.
import '../../../../../node_modules/mapbox-gl/dist/mapbox-gl.css';
import { BotMapView } from '../botMapView/botMapView';
import { translate } from '../../../common/translation/translate';
import { ErrorBoundary } from '../errorBoundary/errorBoundary';

interface MapWidgetBodyProps {
    latitude: number;
    longitude: number;
    mapboxAccessToken: string;
    authId: string;
    secret: string;
    mapBaseUrl: string;
    tileBaseUrl: string;
    stdParameters: Record<string, unknown>;
    isBot: boolean;
    defaultMapLayerId: string;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { appState } = storeState || {};
    const { mapboxAccessToken, authId, secret, mapBaseUrl, stdParameters, tileBaseUrl, user, defaultMapLayerId } = appState?.appState || {};
    const { Latitude: latitude, Longitude: longitude } = user?.ActiveLocation?.Locality || {};
    const { IsBot } = user || {};

    return {
        latitude,
        longitude,
        mapboxAccessToken,
        authId,
        secret,
        mapBaseUrl,
        stdParameters,
        tileBaseUrl,
        isBot: IsBot,
        defaultMapLayerId
    };
};

const mapDispatchToProps = {};

const RadarMapWidgetBody = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    latitude,
    longitude,
    mapboxAccessToken,
    authId,
    secret,
    mapBaseUrl,
    stdParameters,
    defaultMapLayerId,
    isBot,
    tileBaseUrl }: MapWidgetBodyProps) => {

    const isValidLatLon = Number.isFinite(latitude) && Number.isFinite(longitude);

    if (isBot) {
        return (
            <Container>
                <BotMapView>{translate('weatherRadarMap')}</BotMapView>
            </Container>
        );
    }

    return (
        <Container>
            <ErrorBoundary errorDescription={translate('dataLoadErrorMessage')}>
                {isValidLatLon && <Map
                    mapboxAccessToken={mapboxAccessToken}
                    initialLongitude={longitude}
                    initialLatitude={latitude}
                    initialZoom={6}
                    longitude={longitude}
                    latitude={latitude}
                    smallPinImageUrl='/images/map-pin-default.png'
                    bigPinImageUrl='/images/map-pin-default.png'
                    extension={(map: InstanceType<Map>, latitude: number, longitude: number) =>
                    { 
                        return map && <RasterLayer
                            map={map}
                            latitude={latitude}
                            longitude={longitude}
                            mapBaseUrl={mapBaseUrl}
                            tileBaseUrl={tileBaseUrl}
                            authId={authId}
                            secret={secret}
                            stdApiParameters={stdParameters}
                            defaultLayerId={defaultMapLayerId}/>; }
                    }></Map>}
            </ErrorBoundary>
        </Container>
    );
});

RadarMapWidgetBody.displayName = 'RadarMapWidgetBody';

const Container = styled.div`
    display: flex;
    height: 213px;
`;

export { RadarMapWidgetBody as default };
